<template>
  <div class="contact-details">
    <p v-if="text('iti_campoextra2')">
      <ContentLink :to="'mailto:' + text('iti_campoextra2')">{{
        text('iti_campoextra2')
      }}</ContentLink>
    </p>
    <p v-if="text('iti_campoextra3')">
      <ContentLink :to="'tel:' + text('iti_campoextra3').replace(/[^+0-9]/g, '')">{{
        text('iti_campoextra3')
      }}</ContentLink>
    </p>
    <p v-if="text('iti_campoextra4')">
      <ContentLink
        :to="whatsappLink(text('iti_campoextra4'))"
        v-if="whatsappLink(text('iti_campoextra4'))"
        >{{ text('iti_campoextra4') }}</ContentLink
      >
      <span v-else>{{ text('iti_campoextra4') }}</span>
    </p>
    <p v-if="text('iti_campoextra5')">{{ text('iti_campoextra5') }}</p>
    <iframe
      v-if="mapUrl"
      :src="mapUrl"
      title="Localização"
      loading="lazy"
      referrerpolicy="no-referrer"
      class="contact-map"
    />
  </div>
</template>
<script>
import ContentLink from './ContentLink.vue';
import { whatsappLink } from '@/services/phoneLinks';
import { contentValue, plainText } from '@/services/contentApi';
export default {
  name: 'ContactDetails',
  components: { ContentLink },
  props: { item: Object },
  computed: {
    mapUrl() {
      const value = String(contentValue(this.item, 'iti_campoextra1'));
      const source = value.includes('<')
        ? new DOMParser()
            .parseFromString(value, 'text/html')
            .querySelector('iframe')
            ?.getAttribute('src')
        : value;
      try {
        const url = new URL(source);
        return url.protocol === 'https:' &&
          /^(www\.)?google\.(com|com\.br)$/.test(url.hostname) &&
          url.pathname.startsWith('/maps')
          ? url.href
          : '';
      } catch {
        return '';
      }
    },
  },
  methods: {
    whatsappLink,
    text(field) {
      return plainText(contentValue(this.item, field));
    },
  },
};
</script>
